import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=ea95b3be&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=ea95b3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea95b3be",
  null
  
)

export default component.exports